import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M1.5 19l18 -18","key":"svg-0"}],["path",{"d":"M4.5 22l18 -18","key":"svg-1"}],["path",{"d":"M18 15l3 4","key":"svg-2"}],["path",{"d":"M23 15l-4.5 8","key":"svg-3"}],["path",{"d":"M1 1l6 6","key":"svg-4"}],["path",{"d":"M1 7l6 -6","key":"svg-5"}]]

const IconMathXFloorDivideY = createReactComponent('outline', 'math-x-floor-divide-y', 'MathXFloorDivideY', __iconNode);

export default IconMathXFloorDivideY;